<template>
  <div>
    <div>
      <CustomLoader v-if="isLoading" :width="70"></CustomLoader>
      <!-- <loading :active.sync="isLoading" loader="spinner" color="#36304a" :width="70"></loading> -->
    </div>

    <b-card class="mainCardBG">
      <b-card-text>
        <b-navbar
          class="formCard"
          style="border-radius: 5px !important; padding-left: 0px"
          toggleable="lg"
          type="dark"
          variant="primary"
        >
          <b-navbar-nav>
            <b-button @click="previousDash" size="sm" variant="light">
              <md-icon icon="gear-fill" aria-hidden="true"
                >skip_previous</md-icon
              >Back
            </b-button>
          </b-navbar-nav>
          <b-navbar-brand center>Reports</b-navbar-brand>
        </b-navbar>
        <b-card class="formCard">
          <b-card-text>
            <div class="gutr">
              <!-- Using modifiers -->
              <b-button variant="outline-dark" v-b-toggle.collapse-2 class="m-1"
                >Filters</b-button
              >
              <b-dropdown
                size="sm"
                dropleft
                variant="outline-dark"
                text="Export"
                class="m-2 pull-right"
              >
                <b-dropdown-item-button @click="onDownloadPDF"
                  >Export as PDF</b-dropdown-item-button
                >
                <b-dropdown-item-button @click="onDownloadExcel"
                  >Export as Excel</b-dropdown-item-button
                >
              </b-dropdown>

              <b-collapse id="collapse-2">
                <b-card class="gutr">
                  <md-layout md-gutter>
                    <!-- <md-layout
                      md-flex="20"
                      v-if="reportSearchField!='clientType1' && reportSearchField!='clientType2' "
                      md-flex-small="100"
                    >
                      <model-list-select
                        :list="cTypeList"
                        v-model="clientType"
                        option-value="cTypeVal"
                        option-text="cTypeText"
                        placeholder="Select Client / Lead  "
                      ></model-list-select>
                    </md-layout>
                    <md-layout
                      md-flex="5"
                      v-if="reportSearchField!='clientType1' && reportSearchField!='clientType2' "
                    ></md-layout>-->
                    <md-layout md-flex="30" md-flex-small="100">
                      <model-list-select
                        :isDisabled="clientType == '2'"
                        :list="clientMaster"
                        id="clientNamenew"
                        v-model="clientId"
                        option-value="clientId"
                        option-text="clientName"
                        placeholder="Select  Client Name"
                      ></model-list-select>
                    </md-layout>
                    <!-- <md-layout md-flex="5"></md-layout>
                    <md-layout
                      md-flex="20"
                      v-if="reportSearchField!='export1' && reportSearchField!='import1'  && reportSearchField!='export2'  && reportSearchField!='import2' "
                      md-flex-small="100"
                    >
                      <model-list-select
                        :list="transportTypeName"
                        v-model="transportType"
                        option-value="transportTypeVal"
                        option-text="transportTypeText"
                        placeholder="Select Export / Import"
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout
                      md-flex="15"
                      v-if="reportSearchField!='export1' && reportSearchField!='import1'  && reportSearchField!='export2'  && reportSearchField!='import2' "
                      md-flex-small="100"
                    >
                      <model-list-select
                        :list="shipmentTypeList"
                        v-model="shipmentType"
                        option-value="shipmentTypeVal"
                        option-text="shipmentTypeText"
                        placeholder="Select Sea / Air"
                      ></model-list-select>
                    </md-layout>-->
                  </md-layout>
                  <!-- <md-layout md-gutter class="gutr">
                    <md-layout md-flex="20" md-flex-small="100">
                      <model-list-select
                        :list="jTypeList"
                        v-model="jobType"
                        option-value="jTypeVal"
                        option-text="jTypeText"
                        placeholder="Select Job Type "
                      ></model-list-select>
                    </md-layout>
                    <md-layout md-flex="5" v-if="jobType!=''"></md-layout>
                    <md-layout md-flex="30" v-if="jobType!=''" md-flex-small="100">
                      <model-list-select
                        :list="eqExList"
                        v-model="enqOrExu"
                        option-value="eVal"
                        option-text="eText"
                        placeholder="Select Enquiry / Execution "
                      ></model-list-select>
                    </md-layout>
                  </md-layout>-->
                  <div class="gutr">
                    <b-button
                      size="sm"
                      class="pull-right"
                      @click="viewFFExportFCL('0', '1')"
                      variant="outline-primary"
                      >Search</b-button
                    >
                    <b-button
                      style="margin-right: 5px"
                      size="sm"
                      class="pull-right"
                      @click="clearFilter"
                      variant="outline-info"
                      >clear</b-button
                    >
                  </div>

                  <!-- <md-layout md-gutter>
                    <md-layout md-flex="30" md-flex-small="100">
                      <b-input
                        id="inline-form-input-name"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="filterClient"
                        placeholder="Search Client"
                        @input="viewFFExportFCL('0','1')"
                      ></b-input>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30" md-flex-small="100">
                      <b-input
                        id="inline-form-input-name"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="searchValPickup"
                        placeholder="Search Pickup"
                        @input="viewFFExportFCL('0','1')"
                      ></b-input>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30" md-flex-small="100">
                      <b-input
                        id="inline-form-input-name"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="searchValHandover"
                        placeholder="Search Handover"
                        @input="viewFFExportFCL('0','1')"
                      ></b-input>
                    </md-layout>
                  </md-layout>
                  <md-layout md-gutter class="gutr">
                    <md-layout md-flex="30" md-flex-small="100">
                      <b-input
                        id="inline-form-input-name"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="searchValPOR"
                        placeholder="Search POR"
                        @input="viewFFExportFCL('0','1')"
                      ></b-input>
                    </md-layout>

                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30" md-flex-small="100">
                      <b-input
                        id="inline-form-input-name"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="searchValPOD"
                        placeholder="Search POD"
                        @input="viewFFExportFCL('0','1')"
                      ></b-input>
                    </md-layout>
                    <md-layout md-flex="5"></md-layout>
                    <md-layout md-flex="30" md-flex-small="100">
                      <b-input
                        id="inline-form-input-name"
                        class="mb-2 mr-sm-2 mb-sm-0"
                        v-model="searchValLP"
                        placeholder="Search Load Port"
                        @input="viewFFExportFCL('0','1')"
                      ></b-input>
                    </md-layout>
                  </md-layout>-->
                </b-card>
              </b-collapse>
            </div>
            <div class="page-header pull-right">
              <div class="input-group">
                <date-picker
                  class="pull-right"
                  v-model="dateRangeEnq"
                  range
                  :lang="langEnq"
                  format="YYYY-MM-DD"
                  confirm
                  @input="onConfirmDateRangeEq"
                ></date-picker>
              </div>
            </div>
            <div class="gutr">
              <b-table
                show-empty
                stacked="md"
                responsive
                :items="consoBooking"
                :fields="fields"
                :per-page="perPage"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDesc"
                :sort-direction="sortDirection"
              >
                <template slot="mainEnquiryId" slot-scope="row0">
                  <span>{{
                    row0.index + 1 + (currentPage - 1) * perPage
                  }}</span>
                </template>
                <template slot="mainEnquirySeries" slot-scope="row1">
                  <span>Enquiry No. : {{ row1.item.mainEnquirySeries }}</span>
                  <br />
                  <span>
                    Enquiry Type : {{ row1.item.jobType }} -
                    {{ row1.item.shipmentType == "1" ? "Sea" : "Air" }}
                    {{ row1.item.transportType }}
                    <md-icon>{{
                      row1.item.shipmentType == "1"
                        ? "directions_boat"
                        : "flight_takeoff"
                    }}</md-icon>
                  </span>

                  <br />
                  <span
                    v-if="
                      row1.item.multipleContainerType != '' &&
                      row1.item.multipleContainerType != null
                    "
                  >
                    Container Type : {{ row1.item.multipleContainerType }}
                    <br />
                  </span>

                  <span
                    v-if="row1.item.pickup != '' && row1.item.pickup != null"
                  >
                    Pickup : {{ row1.item.pickup }}
                    <br />
                  </span>

                  <span
                    v-if="
                      row1.item.stuffingLoc != '' &&
                      row1.item.stuffingLoc != null
                    "
                  >
                    Stuffing : {{ row1.item.stuffingLoc }}
                    <br />
                  </span>

                  <span
                    v-if="
                      row1.item.handover != '' && row1.item.handover != null
                    "
                  >
                    Handover : {{ row1.item.handover }}
                    <br />
                  </span>

                  <span v-if="row1.item.POR != '' && row1.item.POR != null">
                    Place of Receipt : {{ row1.item.POR }}
                    <br />
                  </span>

                  <div v-if="row1.item.jobType.split(',').includes('FF')">
                    <span v-if="row1.item.LP != '' && row1.item.LP != null">
                      Load Port : {{ row1.item.LP }}
                      <br />
                    </span>

                    <span v-if="row1.item.POD != '' && row1.item.POD != null">
                      Port of Discharge : {{ row1.item.POD }}
                      <br />
                    </span>

                    <span
                      v-if="
                        row1.item.finalPlace != '' &&
                        row1.item.finalPlace != null
                      "
                    >
                      Final Place of Delivery : {{ row1.item.finalPlace }}
                      <br />
                    </span>
                    <span
                      v-if="
                        row1.item.departAirport != '' &&
                        row1.item.departAirport != null
                      "
                    >
                      Departure Airport : {{ row1.item.departAirport }}
                      <br />
                    </span>
                    <span
                      v-if="
                        row1.item.destiAirport != '' &&
                        row1.item.destiAirport != null
                      "
                    >
                      Destination Airport : {{ row1.item.destiAirport }}
                      <br />
                    </span>
                  </div>
                  <span>Enquiry Date : {{ row1.item.loginTime | moment }}</span>
                  <br />
                  <span>Raised From : {{ row1.item.EmpLoc }}</span>
                  <br />
                  <span>Raised By : {{ row1.item.employeeName }}</span>
                </template>

                <template slot="clientName" slot-scope="row11">
                  <b>
                    {{ row11.item.clientName }}
                    <br />
                  </b>
                  <h6 v-if="row11.item.clientType == '2'">
                    <b-badge variant="light">Lead</b-badge>
                  </h6>
                </template>
                <!-- <template slot="allModuleId" slot-scope="row10">
                  <div v-if="row10.item.mainSalesSeries!='' && row10.item.mainSalesSeries!=null">
                    <span>
                      Execution No. : {{row10.item.mainSalesSeries}}
                      <br>
                    </span>
                    <span>
                      Executed Job Type : {{row10.item.exeuJobType}}
                      <br>
                    </span>
                    <div v-if="row10.item.shipmentType=='1'">
                      <span>
                        Container Type : {{row10.item.multipleContainerType}}
                        <br>
                      </span>
                      <span>
                        No. of Containers : {{row10.item.multiConNo}}
                        <br>
                      </span>
                      <span v-if="row10.item.shippingLine!='' && row10.item.shippingLine!=null ">
                        Shipping Line : {{row10.item.shippingLine}}
                        <br>
                      </span>
                    </div>
                    <div v-else>
                      <span>
                        No. of Packages : {{row10.item.exeuPkg}}
                        <br>
                      </span>
                      <span>
                        Airline Name : {{row10.item.exeuAirline}}
                        <br>
                      </span>
                    </div>
                  </div>
                  <div v-else>
                    <span class="error">EXECUTION NOT STARTED</span>
                  </div>
                </template>-->
                <!-- <template slot="loginTime" slot-scope="row5">
                <span>{{row5.item.loginTime}}</span>
                </template>-->
              </b-table>
            </div>

            <div>
              <b-pagination
                class="mt-4 pull-right"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                @change="onPageChange($event)"
                first-text="⏮"
                prev-text="⏪"
                next-text="⏩"
                last-text="⏭"
              ></b-pagination>
            </div>
          </b-card-text>
        </b-card>
      </b-card-text>
    </b-card>

    <!-- FF Starts Here -->
    <!-- TPT Ends Here -->
  </div>
</template>

<script>
import axios from "axios";
import moment from "moment";
import DatePicker from "vue2-datepicker";
// import Loading from "vue-loading-overlay";
import CustomLoader from "../../common/customLoader.vue";
import "vue-loading-overlay/dist/vue-loading.css";
import { ModelListSelect } from "vue-search-select";
import { URL_BASE, URL_BASE_DOC } from "../../../helper/constant.js";
import { DateFormat, selectDateFormat } from "../../../helper/filters";
import {
  globalPermissionStatus,
  GlobalContainerValid,
} from "../../../helper/collection";
import XLSX from "xlsx";
import jsPDF from "jspdf";
import "jspdf-autotable";

export default {
  beforeMount() {
    this.$store.dispatch("setCurrentRoute", "/dashboard");
    if (
      this.$sessionsStorage.get("loginId") != undefined &&
      this.$sessionsStorage.get("loginId") != "" &&
      this.$sessionsStorage.get("departmentName") != undefined &&
      this.$sessionsStorage.get("departmentName") != "" &&
      this.$sessionsStorage.get("designation") != undefined &&
      this.$sessionsStorage.get("designation") != ""
    ) {
      let { filterId } = this.$route.params;
      let { dateRange } = this.$route.params;
      this.reportSearchField = filterId;
      if (dateRange != "" && dateRange != undefined) {
        this.dateRangeEnq = dateRange.split(",");
      }
      //    const { price } = this.$route.params;
      console.log(this.dateRangeEnq, " fom");
      this.viewFFExportFCL("0", "1", "1");
    } else {
      this.$sessionsStorage.set("loginId", "");
      this.$router.push({
        path: "/Login/",
      });
    }
  },

  data() {
    return {
      reportSearchField: "",
      particularStatus: "0",
      name: "BootstrapVue",
      show: true,
      headerFilter: [],
      docURL: URL_BASE_DOC,
      containerNoRegexError: "",
      containerNo: "",
      validContainerNo: "",
      totalRows: "",
      currentPage: 2,
      perPage: 10,
      pageOptions: [20, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filterClient: "",
      searchValPickup: "",
      searchValHandover: "",
      searchValPOR: "",
      searchValPOD: "",
      searchValLP: "",

      fields: [
        {
          key: "mainEnquiryId",
          mainkey: "mainEnquiryId",
          label: "Sr No.",
          sortable: true,
          sortDirection: "ASC",
        },
        {
          key: "clientName",
          mainkey: "clientName",
          label: "Client / Shipper Name",
          sortable: true,
          sortDirection: "ASC",
          table: "B.",
        },
        {
          key: "mainEnquirySeries",
          mainkey: "mainEnquirySeries",
          label: "Enquiry Details",
          sortable: true,
          sortDirection: "ASC",
          table: "A.",
        },

        // {
        //   key: "allModuleId",
        //   mainkey: "allModuleId",
        //   label: "Execution Details",
        //   sortable: true,
        //   sortDirection: "ASC"
        // }
      ],
      isLoading: "",
      alert: {
        content: "Are you sure you want to delete ..!",
        ok: "ok",
      },
      consoBooking: [],
      cTypeList: [
        {
          cTypeVal: "1",
          cTypeText: "Client",
        },
        {
          cTypeVal: "2",
          cTypeText: "Lead",
        },
      ],

      clientType: "",
      clientId: "",
      transportType: "",
      shipmentType: "",
      jobType: "",
      enqOrExu: "",
      clientMaster: [],
      transportTypeName: [
        {
          transportTypeVal: "Export",
          transportTypeText: "Export",
        },
        {
          transportTypeVal: "Import",
          transportTypeText: "Import",
        },
      ],
      shipmentTypeList: [
        {
          shipmentTypeVal: "1",
          shipmentTypeText: "Sea",
        },
        {
          shipmentTypeVal: "2",
          shipmentTypeText: "Air",
        },
      ],
      jTypeList: [
        {
          jTypeVal: "TPT",
          jTypeText: "TPT",
        },
        {
          jTypeVal: "FF",
          jTypeText: "FF",
        },
        {
          jTypeVal: "CC",
          jTypeText: "CC",
        },
      ],
      eqExList: [
        {
          eVal: "1",
          eText: "Enquiry",
        },
        {
          eVal: "2",
          eText: "Execution",
        },
      ],
      dateRangeEnq: [],
      langEnq: {
        pickers: ["", "", "previous 7 days", "previous 30 days"],
      },
      enqPDFHead: [
        "Sr No.",
        "Enquiry No.",
        "Shipper ",
        "Enquiry Type",
        "Export / Import",
        "Shipment Type",
        "Container Type",
        "Place of Receipt",
        "Load Port",
        "Port of Discharge",
        "Final Place of Delivery",
        "Departure Airport",
        "Destination Airport",
        "No. of Packages",
        "Enquiry Raised From",
        "Enquiry Raised By",
        "Enquiry Date",
      ],

      enqPDFColumns: [
        "mainEnquiryId",
        "mainEnquirySeries",
        "clientName",
        "jobType",
        "transportType",
        "shipmentType",
        "multipleContainerType",
        "POR",
        "LP",
        "POD",
        "finalPlace",
        "departAirport",
        "destiAirport",
        "noOfPkg",
        "EmpLoc",
        "employeeName",
        "loginTime",
      ],
      enqPDFHeadSea: [
        "Sr No.",
        "Enquiry No.",
        "Shipper ",
        "Enquiry Type",
        "Export / Import",
        "Shipment Type",
        "Container Type",
        "Place of Receipt",
        "Load Port",
        "Port of Discharge",
        "Final Place of Delivery",
        "Enquiry Raised From",
        "Enquiry Raised By",
        "Enquiry Date",
      ],

      enqPDFColumnsSea: [
        "mainEnquiryId",
        "mainEnquirySeries",
        "clientName",
        "jobType",
        "transportType",
        "shipmentType",
        "multipleContainerType",
        "POR",
        "LP",
        "POD",
        "finalPlace",
        "EmpLoc",
        "employeeName",
        "loginTime",
      ],
      enqPDFHeadAir: [
        "Sr No.",
        "Enquiry No.",
        "Shipper ",
        "Enquiry Type",
        "Export / Import",
        "Shipment Type",
        "Departure Airport",
        "Destination Airport",
        "No of Package",
        "Enquiry Raised From",
        "Enquiry Raised By",
        "Enquiry Date",
      ],
      enqPDFColumnsAir: [
        "mainEnquiryId",
        "mainEnquirySeries",
        "clientName",
        "jobType",
        "transportType",
        "shipmentType",
        "departAirport",
        "destiAirport",
        "noOfPkg",
        "EmpLoc",
        "employeeName",
        "loginTime",
      ],
    };
  },

  mounted() {},
  filters: {
    moment(date) {
      return DateFormat(date);
    },
  },

  beforeDestroy() {},

  destroyed() {},

  components: {
    // Loading,
    CustomLoader,
    DatePicker,
    ModelListSelect,
  },

  computed: {
    buttonDisable() {
      return this.mainModal.ffClientStatus == "2" ||
        this.mainModal.ffExpireStatus == "1"
        ? true
        : false;
    },
    fetchClientType() {
      return this.reportSearchField == "E1" ||
        this.reportSearchField == "E11" ||
        this.reportSearchField == "E11Export" ||
        this.reportSearchField == "E11Import" ||
        this.reportSearchField == "E11ExportFF" ||
        this.reportSearchField == "E11ExportCC" ||
        this.reportSearchField == "E11ExportTPT" ||
        this.reportSearchField == "E11ImportFF" ||
        this.reportSearchField == "E11ImportCC" ||
        this.reportSearchField == "E11ImportTPT" ||
        this.reportSearchField == "E12" ||
        this.reportSearchField == "E12Export" ||
        this.reportSearchField == "E12Import" ||
        this.reportSearchField == "E12ExportFF" ||
        this.reportSearchField == "E12ExportCC" ||
        this.reportSearchField == "E12ExportTPT" ||
        this.reportSearchField == "E12ImportFF" ||
        this.reportSearchField == "E12ImportCC" ||
        this.reportSearchField == "E12ImportTPT"
        ? "1"
        : this.reportSearchField == "L2" ||
          this.reportSearchField == "L21" ||
          this.reportSearchField == "L21Export" ||
          this.reportSearchField == "L21Import" ||
          this.reportSearchField == "L21ExportFF" ||
          this.reportSearchField == "L21ExportCC" ||
          this.reportSearchField == "L21ExportTPT" ||
          this.reportSearchField == "L21ImportFF" ||
          this.reportSearchField == "L21ImportCC" ||
          this.reportSearchField == "L21ImportTPT" ||
          this.reportSearchField == "L22" ||
          this.reportSearchField == "L22Export" ||
          this.reportSearchField == "L22Import" ||
          this.reportSearchField == "L22ExportFF" ||
          this.reportSearchField == "L22ExportCC" ||
          this.reportSearchField == "L22ExportTPT" ||
          this.reportSearchField == "L22ImportFF" ||
          this.reportSearchField == "L22ImportCC" ||
          this.reportSearchField == "L22ImportTPT"
        ? "2"
        : this.clientType;
    },
    fetchShipmentType() {
      return this.reportSearchField == "E11" ||
        this.reportSearchField == "E11Export" ||
        this.reportSearchField == "E11Import" ||
        this.reportSearchField == "E11ExportFF" ||
        this.reportSearchField == "E11ExportCC" ||
        this.reportSearchField == "E11ExportTPT" ||
        this.reportSearchField == "E11ImportFF" ||
        this.reportSearchField == "E11ImportCC" ||
        this.reportSearchField == "E11ImportTPT" ||
        this.reportSearchField == "L21" ||
        this.reportSearchField == "L21Export" ||
        this.reportSearchField == "L21Import" ||
        this.reportSearchField == "L21ExportFF" ||
        this.reportSearchField == "L21ExportCC" ||
        this.reportSearchField == "L21ExportTPT" ||
        this.reportSearchField == "L21ImportFF" ||
        this.reportSearchField == "L21ImportCC" ||
        this.reportSearchField == "L21ImportTPT"
        ? "1"
        : this.reportSearchField == "E12" ||
          this.reportSearchField == "E12Export" ||
          this.reportSearchField == "E12Import" ||
          this.reportSearchField == "E12ExportFF" ||
          this.reportSearchField == "E12ExportCC" ||
          this.reportSearchField == "E12ExportTPT" ||
          this.reportSearchField == "E12ImportFF" ||
          this.reportSearchField == "E12ImportCC" ||
          this.reportSearchField == "E12ImportTPT" ||
          this.reportSearchField == "L22" ||
          this.reportSearchField == "L22Export" ||
          this.reportSearchField == "L22Import" ||
          this.reportSearchField == "L22ExportFF" ||
          this.reportSearchField == "L22ExportCC" ||
          this.reportSearchField == "L22ExportTPT" ||
          this.reportSearchField == "L22ImportFF" ||
          this.reportSearchField == "L22ImportCC" ||
          this.reportSearchField == "L22ImportTPT"
        ? "2"
        : this.shipmentType;
    },
    fetchTransportType() {
      return this.reportSearchField == "E11Export" ||
        this.reportSearchField == "E11ExportFF" ||
        this.reportSearchField == "E11ExportCC" ||
        this.reportSearchField == "E11ExportTPT" ||
        this.reportSearchField == "E12Export" ||
        this.reportSearchField == "E12ExportFF" ||
        this.reportSearchField == "E12ExportCC" ||
        this.reportSearchField == "E12ExportTPT" ||
        this.reportSearchField == "L21Export" ||
        this.reportSearchField == "L21ExportFF" ||
        this.reportSearchField == "L21ExportCC" ||
        this.reportSearchField == "L21ExportTPT" ||
        this.reportSearchField == "L22Export" ||
        this.reportSearchField == "L22ExportFF" ||
        this.reportSearchField == "L22ExportCC" ||
        this.reportSearchField == "L22ExportTPT"
        ? "Export"
        : this.reportSearchField == "E11Import" ||
          this.reportSearchField == "E11ImportFF" ||
          this.reportSearchField == "E11ImportCC" ||
          this.reportSearchField == "E11ImportTPT" ||
          this.reportSearchField == "E12Import" ||
          this.reportSearchField == "E12ImportFF" ||
          this.reportSearchField == "E12ImportCC" ||
          this.reportSearchField == "E12ImportTPT" ||
          this.reportSearchField == "L21Import" ||
          this.reportSearchField == "L21ImportFF" ||
          this.reportSearchField == "L21ImportCC" ||
          this.reportSearchField == "L21ImportTPT" ||
          this.reportSearchField == "L22Import" ||
          this.reportSearchField == "L22ImportFF" ||
          this.reportSearchField == "L22ImportCC" ||
          this.reportSearchField == "L22ImportTPT"
        ? "Import"
        : this.transportType;
    },
    fetchJobType() {
      return this.reportSearchField == "E11ExportFF" ||
        this.reportSearchField == "E11ImportFF" ||
        this.reportSearchField == "E12ExportFF" ||
        this.reportSearchField == "E12ImportFF" ||
        this.reportSearchField == "L21ExportFF" ||
        this.reportSearchField == "L21ImportFF" ||
        this.reportSearchField == "L22ExportFF" ||
        this.reportSearchField == "L22ImportFF"
        ? "FF"
        : this.reportSearchField == "E11ExportCC" ||
          this.reportSearchField == "E11ImportCC" ||
          this.reportSearchField == "E12ExportCC" ||
          this.reportSearchField == "E12ImportCC" ||
          this.reportSearchField == "L21ExportCC" ||
          this.reportSearchField == "L21ImportCC" ||
          this.reportSearchField == "L22ExportCC" ||
          this.reportSearchField == "L22ImportCC"
        ? "CC"
        : this.reportSearchField == "E11ExportTPT" ||
          this.reportSearchField == "E11ImportTPT" ||
          this.reportSearchField == "E12ExportTPT" ||
          this.reportSearchField == "E12ImportTPT" ||
          this.reportSearchField == "L21ExportTPT" ||
          this.reportSearchField == "L21ImportTPT" ||
          this.reportSearchField == "L22ExportTPT" ||
          this.reportSearchField == "L22ImportTPT"
        ? "TPT"
        : this.jobType;
    },
  },
  watch: {
    // containerNo: {
    //   handler(newVal, oldVal) {
    //     let newCon = this.containerNo.toUpperCase();
    //     this.containerNo = newCon;
    //   },
    //   deep: true
    // }

    shipModal: {
      handler: function (newVal, oldVal) {
        if (
          this.shipModal.shippingId != "" &&
          this.shipModal.ffShippingWiseId == ""
        ) {
          let arrayDum = this.ffShipArry.filter((x) => {
            return x.shippingId == this.shipModal.shippingId;
          });

          if (arrayDum.length > 0) {
            this.alert.content = arrayDum[0].shippingLine + " Already Exists";
            this.$refs["addPopAlready"].open();

            return false;
          }
        }
      },

      deep: true,
    },
  },
  methods: {
    onConfirmDateRangeEq() {
      this.viewFFExportFCL("0", "1");
    },
    onDownloadExcel() {
      this.isLoading = true;
      let type_Size = {
        excelData: "abc",
        clientType:
          this.reportSearchField == "clientType1"
            ? "1"
            : this.reportSearchField == "clientType2"
            ? "2"
            : this.clientType,
        clientId: this.clientId,
        transportType:
          this.reportSearchField == "export1" ||
          this.reportSearchField == "export2"
            ? "Export"
            : this.reportSearchField == "import1" ||
              this.reportSearchField == "import2"
            ? "Import"
            : this.transportType,

        shipmentType:
          this.reportSearchField == "export1" ||
          this.reportSearchField == "import1"
            ? "1"
            : this.reportSearchField == "export2" ||
              this.reportSearchField == "import2"
            ? "2"
            : this.shipmentType,

        jobType: this.jobType,
        enqOrExu: this.enqOrExu,
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/reportExportEnqExec.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.EnqPdfReportData.length > 0) {
              console.log(data);
              let mainArray = [];
              data.EnqPdfReportData.map((x, index) => {
                let tempArray = [];

                this.enqPDFColumns.map((y) => {
                  if (x.hasOwnProperty(y)) {
                    x.mainEnquiryId = index + 1;

                    x.mainEnquiryId = index + 1;

                    tempArray.push(x[y]);
                  }
                });

                mainArray.push(tempArray);
              });

              var ffExcelReport = XLSX.utils.json_to_sheet(mainArray);
              var wb = XLSX.utils.book_new();
              wb.Title = "Insert Title Here";
              XLSX.utils.book_append_sheet(wb, ffExcelReport, "SheetOne"); // sheetAName is name of Worksheet
              // XLSX.utils.book_append_sheet(wb, pokemonWS, "pokemons");
              XLSX.writeFile(
                wb,
                "ENQUIRY_REPORT_" + new Date().toDateString() + ".xlsx"
              );
            } else {
              //this.showMessageSnackbar("No data available");
            }
          }

          this.isLoading = false;
        })
        .catch((error) => {});
    },
    onDownloadPDF() {
      this.isLoading = true;
      let type_Size = {
        excelData: "abc",
        clientId: this.clientId,
        clientType: this.fetchClientType,

        shipmentType: this.fetchShipmentType,

        transportType: this.fetchTransportType,

        jobType: this.fetchJobType,

        enqOrExu: this.enqOrExu,

        fromDateRngEnq: this.dateRangeEnq[0],
        toDateRngEnq: this.dateRangeEnq[1],
      };

      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/reportExportEnqExec.php`,
        data: JSON.stringify(type_Size),
        crossDomain: true,

        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            if (data.EnqPdfReportData.length > 0) {
              let mainArray = [];

              data.EnqPdfReportData.map((x, index) => {
                let tempArray = [];
                if (
                  this.reportSearchField == "export1" ||
                  this.reportSearchField == "import1"
                ) {
                  this.enqPDFColumnsSea.map((y) => {
                    if (x.hasOwnProperty(y)) {
                      x.shipmentType = "Sea";
                      x.mainEnquiryId = index + 1;

                      tempArray.push(x[y]);
                    }
                  });
                } else if (
                  this.reportSearchField == "export2" ||
                  this.reportSearchField == "import2"
                ) {
                  this.enqPDFColumnsAir.map((y) => {
                    if (x.hasOwnProperty(y)) {
                      x.shipmentType = "Air";
                      x.mainEnquiryId = index + 1;

                      tempArray.push(x[y]);
                    }
                  });
                } else {
                  this.enqPDFColumns.map((y) => {
                    if (x.hasOwnProperty(y)) {
                      x.mainEnquiryId = index + 1;

                      x.shipmentType == "Sea";

                      tempArray.push(x[y]);
                    }
                  });
                }
                mainArray.push(tempArray);
              });

              //var imgData = BASE64IMAGE;
              let export_Import =
                this.reportSearchField == "export1" ||
                this.reportSearchField == "export2"
                  ? " EXPORT "
                  : this.reportSearchField == "import1" ||
                    this.reportSearchField == "import2"
                  ? " IMPORT "
                  : "";
              let sea_air =
                this.reportSearchField == "export1" ||
                this.reportSearchField == "import1"
                  ? " SEA "
                  : this.reportSearchField == "export2" ||
                    this.reportSearchField == "import2"
                  ? " AIR "
                  : "";

              var doc = new jsPDF("l", "px", [1000, 600]);
              // doc.addImage(imgData, "JPEG", 340, 0, 60, 40);
              doc.text(
                30,
                53,

                "ENQUIRY REPORT FOR " + sea_air + export_Import
                // +
                //   this.FromDate +
                //   " TO " +
                //   this.ToDate
              );
              // doc.text(230, 53, "GOGO CINEMA SHOW DATE REPORT FOR ");
              doc.setFontSize(17);

              doc.autoTable({
                head: [
                  this.reportSearchField == "export1" ||
                  this.reportSearchField == "import1"
                    ? this.enqPDFHeadSea
                    : this.reportSearchField == "export2" ||
                      this.reportSearchField == "import2"
                    ? this.enqPDFHeadAir
                    : this.enqPDFHead,
                ],
                theme: "grid", // 'striped'|'grid'|'plain'
                body: mainArray,
                margin: { top: 60 },
                headStyles: {
                  // fillColor: [209, 46, 30, 1]
                  // fillColor: [195, 66, 0]
                  fillColor: [210, 29, 29],
                },
              });
              doc.save("ENQUIRY_REPORT" + new Date().toDateString() + ".pdf");
            }
            this.isLoading = false;
          }
        })
        .catch((error) => {});
    },

    onPageChange: function (event) {
      let CURRENT = 0;
      if (event == "1") {
        CURRENT = 0;
      } else {
        CURRENT = event * this.perPage - this.perPage;
      }

      this.viewFFExportFCL(CURRENT, "2", event);

      // let totalRows = 1064 / this.perPage;
      // if(this.totalRow )
    },
    previousDash() {
      window.history.go(-1);
    },
    clearFilter() {
      this.clientType = "";
      this.clientId = "";
      this.transportType = "";
      this.shipmentType = "";
      this.jobType = "";
      this.enqOrExu = "";
      this.viewFFExportFCL("0", "1");
    },

    viewFFExportFCL(CURRENT, SEARCH, pageNumber) {
      this.isLoading = true;
      let payload = {
        clientId: this.clientId,
        clientType: this.fetchClientType,

        shipmentType: this.fetchShipmentType,

        transportType: this.fetchTransportType,

        jobType: this.fetchJobType,

        enqOrExu: this.enqOrExu,
        fromDateRngEnq: this.dateRangeEnq[0],
        toDateRngEnq: this.dateRangeEnq[1],

        fields: this.fields,
        fromSearch: SEARCH,
        currentPage: CURRENT,
        perPage: this.perPage,

        assignmentNo: "assignmentNo",
        pageName: "1",
      };
      console.log(payload);
      let options = {
        method: "POST",
        url: `${URL_BASE}/Api_EmpDashboard/getDashboardReportsDetails.php`,
        data: JSON.stringify(payload),
        crossDomain: true,
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
          Authorization: this.$sessionsStorage.get("loginId"),
        },
      };
      axios(options)
        .then((result) => {
          const { statusText, status, data } = result;
          if (status == 200 && data) {
            console.log(data);
            if (SEARCH != "2") {
              this.currentPage = 1;
              this.totalRows = data.totalData;
            } else {
              this.currentPage = pageNumber;
            }
            if (data.mainEnqData.length > 0) {
              this.consoBooking = data.mainEnqData;
            } else {
              this.consoBooking = [];
            }
            if (data.clientMaster.length > 0) {
              this.clientMaster = data.clientMaster;
            } else {
              this.consoBooking = [];
            }
            this.isLoading = false;
            // this.JqueryFun();
          }
        })
        .catch((error) => {});
    },
  },
};
</script>
<style scoped>
.appMargin0 {
  margin-left: 0px !important;
  margin-right: 100px;
  transition: 5s !important;
}
.modal fade show d-block {
  background: none;
}
</style>



// WEBPACK FOOTER //
// dashboardReportsDetails.vue?4d65aa84